/**
 * 字段加密需要用到
 */
// 手动按需引入

/* eslint-disable */
require('node-forge/lib/aes.js');
require('node-forge/lib/cipher.js');
require('node-forge/lib/cipherModes.js');
require('node-forge/lib/util.js');
require('node-forge/lib/baseN.js');

const forge = require('node-forge/lib/forge.js');

export default forge;
